module.exports = __webpack_public_path__ + "img/6.921b7d28.jpg";